import { fetchPublicIp } from './useNetworkStatus';

const appVersion = process.env.APP_VERSION || process.env.npm_package_version || 'unknown';

export function isNetworkError(error) {
  const message = (error?.message || '').toLowerCase();
  return (
    message.includes('network') ||
    message.includes('timeout') ||
    error?.code === 'NETWORK_ERROR' ||
    error?.code === 'ERR_NETWORK' ||
    error?.code === 'ECONNABORTED' ||
    error?.code === 'ETIMEDOUT'
  );
}

export async function diagnoseConnectivity(error, options = {}) {
  const { forceIpCheck = false } = options;

  const has403 = error?.response?.status === 403;
  const networkError = isNetworkError(error);
  const browserOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;

  let publicIp = null;
  let hasInternet = browserOnline;

  // Quando houver erro de rede (ou 403), tentamos confirmar conectividade externa via IP público.
  if ((networkError || has403 || forceIpCheck) && browserOnline) {
    publicIp = await fetchPublicIp();
    hasInternet = !!publicIp;
  }

  return {
    appVersion,
    has403,
    networkError,
    browserOnline,
    hasInternet,
    publicIp,
    isOffline: networkError && !hasInternet,
    shouldRedirectRejected: has403
  };
}

export function createForbiddenRedirectGuard(options = {}) {
  const {
    requiredConsecutive403 = 2,
    windowMs = 20000
  } = options;

  let last403At = 0;
  let consecutive403 = 0;

  const reset = () => {
    last403At = 0;
    consecutive403 = 0;
  };

  const register403 = () => {
    const now = Date.now();
    const withinWindow = now - last403At <= windowMs;

    consecutive403 = withinWindow ? consecutive403 + 1 : 1;
    last403At = now;

    return consecutive403 >= requiredConsecutive403;
  };

  return {
    reset,
    register403
  };
}
